import { Link as RouterLink } from 'react-router-dom';
import { Box, Link, Stack } from '@mui/material';
import { PageUrl } from 'const/page-url';
import { BlogCategory, categoryPath } from 'const/blog/categories';

// ==============================|| ブログのパンくず ||============================== //
//
// 「ホーム ／ お役立ち記事（／ カテゴリ ／ 記事名）」を出す。
// 一覧・カテゴリ一覧・記事の3つで使う。表示の階層は、各ページが出している
// BreadcrumbList の構造化データと同じ並びにそろえてある。
//
// 記事ページでカテゴリを挟んでいるのは、戻る道を作るためと、
// 全記事からカテゴリ一覧へ内部リンクが張られる形にするため。
//
// 最後の階層(いま見ているページ)はリンクにしない。押しても同じページに来るだけで、
// 「押せるのに何も起きない」リンクは読み上げ環境でも邪魔になるため。

const linkSx = { color: '#6b7280', fontSize: '0.8rem', fontWeight: 600 };
const currentSx = {
    color: '#9ca3af',
    fontSize: '0.8rem',
    fontWeight: 600,
    // 記事名は長いので、1行に収まらない分は省略する
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    maxWidth: { xs: 160, sm: 360 }
};

const Separator = () => (
    <Box component="span" aria-hidden="true" sx={{ color: '#d1d5db', fontSize: '0.8rem' }}>
        ／
    </Box>
);

/**
 * current にいま見ているページ名を渡すと、末尾にリンクなしで並ぶ。
 * category を渡すと「お役立ち記事」と current の間にカテゴリが挟まる(記事ページ用)。
 */
const BlogBreadcrumb = ({ category, current }: { category?: BlogCategory; current?: string }) => (
    <Stack
        component="nav"
        aria-label="パンくずリスト"
        direction="row"
        spacing={1}
        alignItems="center"
        flexWrap="wrap"
        useFlexGap
    >
        <Link component={RouterLink} to="/" underline="hover" sx={linkSx}>
            ホーム
        </Link>
        <Separator />
        {current ? (
            <>
                <Link component={RouterLink} to={PageUrl.Blog.urlWithSlash} underline="hover" sx={linkSx}>
                    お役立ち記事
                </Link>
                <Separator />
                {category && (
                    <>
                        <Link component={RouterLink} to={categoryPath(category.slug)} underline="hover" sx={linkSx}>
                            {category.label}
                        </Link>
                        <Separator />
                    </>
                )}
                <Box component="span" sx={currentSx}>
                    {current}
                </Box>
            </>
        ) : (
            <Box component="span" sx={currentSx}>
                お役立ち記事
            </Box>
        )}
    </Stack>
);

export default BlogBreadcrumb;
